import state from '@/store/modules/Checkout/state'
import getters from '@/store/modules/Checkout/getters'
import mutations from '@/store/modules/Checkout/mutations'
import actions from '@/store/modules/Checkout/actions'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
